import React from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import AuthContextProvider from './contexts/authContext';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import AppRoutes from './routes/appRoutes';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalConfig';

function App() {
    return (
        <Provider store={store}>
            <MsalProvider instance={msalInstance}>
                <AuthContextProvider>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={
                            process.env.REACT_APP_CAPTCHA_KEY as string
                        }
                    >
                        <AppRoutes />
                    </GoogleReCaptchaProvider>
                </AuthContextProvider>
            </MsalProvider>
        </Provider>
    );
}

export default App;
